var ReactTimeAgo = require('./commonjs/ReactTimeAgo').default

exports = module.exports = ReactTimeAgo
exports['default']       = ReactTimeAgo


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-time-ago/no-tooltip.js
// module id = 1658
// module chunks = 0